import moment from 'moment';
import { formatUTCdateWithTime } from '../general';

/** @type {import('./_types').DisplayField[]} */
export const displayFields = [
  {
    label: 'Campaign ID',
    field: 'campaign_id',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: false
  },
  {
    label: 'Campaign Name',
    field: 'campaign_name',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: true
  },
  {
    label: 'Campaign Owner',
    field: 'campaign_owner_name',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: false
  },
  {
    label: 'Vendor',
    field: 'vendor',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: false
  },
  {
    label: 'Campaign Type',
    field: 'campaign_type_name',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: true
  },
  {
    label: 'Status',
    field: 'campaign_status_name',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: true
  },
  {
    label: 'Unique Identifier',
    field: 'unique_identifier',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: false
  },
  {
    label: 'Parent Campaign',
    field: 'parent_campaign_name',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: false
  },
  {
    label: 'Is Manual',
    field: 'is_manual',
    type: 'shared',
    selector: row => row.is_manual ? 'Yes' : 'No',
    cell : row => row.is_manual ? 'Yes' : 'No',
    contexts: ['all'],
    category: 'basic',
    isDefault: false
  },
  {
    label: 'Description',
    field: 'description',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: false
  },
  {
    label: 'Last Status Update',
    field: 'last_status_update',
    type: 'shared',
    selector: row => row.last_status_update ? formatUTCdateWithTime(row.last_status_update) : '',
    cell: row => row.last_status_update ? formatUTCdateWithTime(row.last_status_update) : '',
    contexts: ['all'],
    category: 'basic',
    isDefault: false
  },
  {
    label: 'Start Date',
    field: 'start_date',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: true
  },
  {
    label: 'End Date',
    field: 'end_date',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: true
  },
  {
    label: '# of Prospects',
    field: 'num_of_prospects',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: true
  },
  {
    label: '# of Responses',
    field: 'num_of_responses',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: true
  },
  {
    label: 'Next Step',
    field: 'next_step',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: false
  },
  {
    label: 'Next Step Date',
    field: 'next_step_date',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: false
  },
  {
    label: 'Next Step Poc',
    field: 'next_step_poc',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: false
  },
  {
    label: 'Company Segment',
    field: 'company_segment_name',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: false
  },
  {
    label: '# Converted',
    field: 'num_of_prospects_converted',
    type: 'shared',
    contexts: ['all'],
    category: 'basic',
    isDefault: true
  },
];
export const getDefaultFields = () => displayFields.filter(f => f.isDefault);
/**
 * @param {string[] | null} keys
 */
export const getDisplayFields = (isDefault=false,keys = null) => {
  const visibleFields = displayFields.filter(f => isDefault ? f.isDefault : true);

  if (!keys||keys.length==0) return visibleFields;

  return keys
    .map(key => visibleFields.find(f => f.field === key))
    .filter(Boolean);
};

// export const getDefaultFields = () => displayFields.filter(f => f.isDefault).map(f => f.field);

// export const getDisplayColumnsByOrder = (order = []) =>
//   order.map(key => {
//     const field = displayFields.find(f => f.field === key);
//     if (!field) return null;

//     const base = {
//       id: field.field,
//       name: field.label,
//       selector: row => row[field.field],
//       sortable: true,
//       width: '1fr',
//     };

//     // special formatting
//     if (['start_date', 'end_date', 'next_step_date'].includes(field.field)) {
//       return { ...base, cell: row => row[field.field] ? moment(row[field.field]).format("YYYY/MM/DD") : '' };
//     }

//     if (field.field === 'last_status_update') {
//       return { ...base, cell: row => row[field.field] ? formatUTCdateWithTime(row[field.field]) : '' };
//     }

//     if (field.field === 'is_manual') {
//       return { ...base, cell: row => row[field.field] ? 'Yes' : 'No' };
//     }

//     return { ...base, cell: row => row[field.field] };
//   }).filter(Boolean);
